var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59013 5.96366C2.8011 5.75276 3.08719 5.63428 3.3855 5.63428C3.68381 5.63428 3.96991 5.75276 4.18088 5.96366L9.74963 11.5324L15.3184 5.96366C15.5306 5.75873 15.8147 5.64534 16.1097 5.6479C16.4047 5.65047 16.6868 5.76878 16.8954 5.97737C17.104 6.18595 17.2223 6.46811 17.2249 6.76309C17.2274 7.05806 17.1141 7.34223 16.9091 7.55441L10.545 13.9185C10.334 14.1294 10.0479 14.2479 9.74963 14.2479C9.45132 14.2479 9.16522 14.1294 8.95425 13.9185L2.59013 7.55441C2.37922 7.34344 2.26074 7.05735 2.26074 6.75904C2.26074 6.46073 2.37922 6.17463 2.59013 5.96366Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.bde8b14506ef27822a0195838b8a98ec.svg";
export { ForwardRef as ReactComponent };